import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { map, switchMap } from 'rxjs';

/**
 * Unlike the management-portal (which has a public onboarding wizard and therefore a
 * dedicated `/login` route), this dashboard has no public area at all - every route requires
 * a session, so an unauthenticated visitor is sent straight into the Auth0 Universal Login
 * redirect instead of via an intermediate `/login` page.
 */
export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);

  return auth.isAuthenticated$.pipe(
    switchMap(isLoggedIn => {
      if (isLoggedIn) {
        return [true] as const;
      }
      return auth
        .loginWithRedirect({ appState: { target: state.url } })
        .pipe(map(() => false));
    })
  );
};
